import React, { Fragment, useMemo, useState } from 'react';
import { useGetProjectsQuery } from '@app/generated/graphql';
import { projectonColumns } from './columns';
import DataGridContainer from '@app/shared/components/DataGridContainer';
import LoadMoreRowsTag from '@app/shared/components/LoadMoreRowsTag';
import { listPageContent } from '@app/shared/hoc/list-page';
import DataGridFetchMore from '@app/shared/components/DataGridFetchMore';
import { useRdgSort } from '@app/shared/hooks/useRdgSort';
import { useDebounce } from 'use-debounce';
import { groupBy as rowGrouper } from 'lodash';
import PageTitle from '@app/shared/components/PageTitle';
import { Typography } from '@material-ui/core';
import { useTypography } from '@app/shared/styles/typography';
import Spacing from '@app/components/common/Spacing';
import { InfoCard } from '@mystiny/ui';
import { ProjectTodoFilter } from './components';

const ProjectTodoList = () => {
  const typographyClasses = useTypography();
  const [filters, setFilters] = useState<any>({
    title: '',
    reference: '',
    industry: '',
  });
  const [value] = useDebounce(filters, 200);
  const [offset, setOffset] = React.useState(0);
  const { handleSort, orderBy, sort } = useRdgSort();

  const [projectStatus, setProjectStatus] = useState<string | null>(null);
  const { data, fetchMore, loading, variables } = useGetProjectsQuery({
    variables: {
      where: {
        title: {
          _ilike: value.title ? `%${value.title}%` : undefined,
        },
        reference: {
          _ilike: value.reference ? `%${value.reference}%` : undefined,
        },
        industry: {
          _ilike: value.industry ? `%${value.industry}%` : undefined,
        },
        ...(projectStatus !== null
          ? {
              step_id: { _eq: projectStatus },
            }
          : { step_id: { _nin: ['draft', 'cancelled'] } }),
      },
      orderBy: orderBy,
    },
    fetchPolicy: 'cache-and-network',
  });

  const budgetList = useMemo(
    () => (
      <DataGridContainer height="80vh">
        <DataGridFetchMore
          fetchMore={fetchMore}
          variables={variables}
          offset={offset}
          setOffset={setOffset}
          sortColumn={sort?.column}
          sortDirection={sort?.direction}
          onSort={handleSort}
          defaultColumnOptions={{ sortable: true, resizable: true }}
          rows={data?.rows || []}
          rowHeight={42}
          columns={projectonColumns}
          rowGrouper={rowGrouper}
          filters={filters}
          onFiltersChange={setFilters}
          enableFilters
        />
        <LoadMoreRowsTag loading={loading} />
      </DataGridContainer>
    ),
    [data, fetchMore, loading, variables, filters, setFilters, offset, setOffset, handleSort, sort]
  );

  return (
    <Fragment>
      <PageTitle
        title={
          <Fragment>
            <Typography variant="h5" color="primary" className={typographyClasses.pageTitle}>
              Todo List (ส่วนกลาง)
            </Typography>
            <Typography variant="body1" color="textPrimary">
              หน้าแสดงรายการคำของบประมาณโครงการที่ท่านต้องตรวจสอบและพิจารณา
            </Typography>
          </Fragment>
        }
      />
      <Spacing />
      <InfoCard noPadding>
        <ProjectTodoFilter index={projectStatus} setIndex={setProjectStatus} />
        {budgetList}
      </InfoCard>
    </Fragment>
  );
};

export default listPageContent(ProjectTodoList);
